import React from 'react';
import { Outlet } from 'react-router-dom';
import { authService } from '@root/app/shared/new-services/auth.service';
import { useSessionBootstrap } from '@root/app/shared/hooks/useSessionBootstrap';
import { usePageTitle } from '@root/app/shared/hooks/usePageTitle';
import { usePageAnalytics } from '@root/app/shared/hooks/usePageAnalytics';
import { useHotjarOnboarding } from '@root/app/shared/hooks/useHotjarOnboarding';
import RouterNavigationSync from '@root/app/routing/RouterNavigationSync';

const AppBootstrap: React.FC = () => {
    const isAuthenticated = authService.isLoggedIn();

    useSessionBootstrap(isAuthenticated);
    usePageTitle();
    usePageAnalytics();
    useHotjarOnboarding();

    return (
        <>
            <RouterNavigationSync />
            <Outlet />
        </>
    );
};

export default AppBootstrap;
